import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { FiX } from 'react-icons/fi';
import { ACCENT_CLASSES, AccentColor } from '../../types/work';

interface Props {
  label: string;
  icon?: string;
  accentColor?: AccentColor;
  onDismiss: () => void;
}

export const ContextStrip: React.FC<Props> = ({ label, icon, accentColor = 'emerald', onDismiss }) => {
  const { darkMode } = useTheme();
  const colors = ACCENT_CLASSES[accentColor];
  return (
    <div className={`flex items-center justify-between px-4 py-2 rounded-lg mb-4 border ${
      darkMode ? `${colors.bg} border-gray-700` : 'bg-gray-50 border-gray-200'
    }`}>
      <div className="flex items-center gap-2">
        {icon && <span>{icon}</span>}
        <span className={`text-sm ${darkMode ? colors.text : 'text-gray-700'}`}>
          Showing items for: <strong>{label}</strong>
        </span>
      </div>
      <button onClick={onDismiss} className={`p-0.5 rounded ${darkMode ? 'hover:bg-gray-800 text-gray-400' : 'hover:bg-gray-100 text-gray-500'}`}>
        <FiX className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
